import { render } from "./ChooseAudios.vue?vue&type=template&id=7e343d41&scoped=true"
import script from "./ChooseAudios.vue?vue&type=script&lang=js"
export * from "./ChooseAudios.vue?vue&type=script&lang=js"

import "./ChooseAudios.vue?vue&type=style&index=0&id=7e343d41&lang=less&scoped=true"

import exportComponent from "E:\\heguang\\bm365\\src\\manage\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e343d41"]])

export default __exports__